import searchLogo from "../assets/images/searchLogo.svg";
import editIcon from '../assets/images/editIcon.png';
import { status } from "./constants";
import TickerHyperLinkComponent from "../components/TickerHyperLinkComponent";

function is_number(char: any) {
    
  return !isNaN(parseInt(char));
}

var myValueFormatter_quantity = (p: any) => {
  let is_n = is_number(p.value);
  if (is_n) {
    return formatNumber_q.format(p.value);
  }
};

const formatNumber_q = new Intl.NumberFormat("en-US", {
  maximumFractionDigits: 2,
});

export const ContractRecallFromRecallDef = [
  {
    headerName: "Contract Id",
    field: "contract_id",
    floatingFilter: false,
    editable: false,
    filter: "agTextColumnFilter",
    lockPinned: true,
    cellClass: "lock-pinned",
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: {
      display: "flex",
      alignItems: "center",
      borderRight: "0.5px solid #E1E1E1",
    },
    minWidth: 80,
    maxWidth: 120,
    suppressSizeToFit: false,
    icons: {
      menu: `<img src="${searchLogo}" />`,
    },
  },
  {
    headerName: "B/L",
    field: "contract_type",
    floatingFilter: false,
    editable: false,
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: {
      display: "flex",
      alignItems: "center",
      borderRight: "1px solid #DFDFDF",
    },
    minWidth: 60,
    maxWidth: 70,
    suppressSizeToFit: false,
    icons: {
      menu: `<img src="${searchLogo}" />`,
    },
  },
  {
    headerName: "Cpty Id",
    field: "cpty_id",
    filter: "agTextColumnFilter",
    floatingFilter: false,
    editable: false,
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: {
      display: "flex",
      alignItems: "center",
      borderRight: "1px solid #DFDFDF",
    },
    minWidth: 90,
    maxWidth: 90,
    suppressSizeToFit: false,
    icons: {
      menu: `<img src="${searchLogo}" />`,
    },
  },
  {
    headerName: "Cpty Name",
    field: "cpty_name",
    floatingFilter: false,
    editable: false,
    filter: "agSetColumnFilter",
    floatingFilterComponentParams: { suppressFilterButton: true },
    hide: true,
    cellStyle: {
      display: "flex",
      alignItems: "center",
      borderRight: "1px solid #DFDFDF",
    },
    minWidth: 170,
    maxWidth: 250,
    suppressSizeToFit: false,
    icons: {
      menu: `<img src="${searchLogo}" />`,
    },
  },
  {
    headerName: "Ticker",
    field: "ticker",
    floatingFilter: false,
    editable: false,
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: {
      display: "flex",
      alignItems: "center",
      borderRight: "1px solid #DFDFDF",
    },
    minWidth: 65,
    maxWidth: 100,
    suppressSizeToFit: false,
    icons: {
      menu: `<img src="${searchLogo}" />`,
    },
    cellRenderer: TickerHyperLinkComponent
  },
  {
    headerName: "Cusip",
    field: "cusip",
    floatingFilter: false,
    editable: false,
    filter: "agTextColumnFilter",
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: {
      display: "flex",
      alignItems: "center",
      borderRight: "0.5px solid #E1E1E1",
    },
    minWidth: 85,
    maxWidth: 110,
    suppressSizeToFit: false,
    icons: {
      menu: `<img src="${searchLogo}" />`,
    }
  },
  {
    headerName: "Security Name",
    field: "secMaster_name",
    floatingFilter: false,
    editable: false,
    hide: true,
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: {
      display: "flex",
      alignItems: "center",
      borderRight: "1px solid #DFDFDF",
    },
    minWidth: 200,
    maxWidth: 250,
    suppressSizeToFit: false,
    icons: {
      menu: `<img src="${searchLogo}" />`,
    },
  },
  {
    headerName: "Contract Qty",
    field: "quantity",
    type: "rightAligned",
    valueFormatter: myValueFormatter_quantity,
    floatingFilter: false,
    filter: "agNumberColumnFilter",
    editable: false,
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: function (params: any) {
      if (params.node.data.quantity < 0) {
        return {
          display: "flex",
          alignItems: "center",
          border: "2px solid red",
          justifyContent: "flex-end",
        };
      } else {
        return {
          display: "flex",
          alignItems: "center",
          borderRight: "1px solid #DFDFDF",
          justifyContent: "flex-end",
        };
      }
    },
    minWidth: 90,
    maxWidth: 130,
    suppressSizeToFit: false,
    icons: {
      menu: `<img src="${searchLogo}" />`,
    },
  },
  {
    headerName: "Recalled Qty",
    field: "recalled_quantity",
    type: "rightAligned",
    valueFormatter: myValueFormatter_quantity,
    floatingFilter: false,
    filter: "agNumberColumnFilter",
    editable: false,
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: function (params: any) {
      if (params.node.data.quantity < 0) {
        return {
          display: "flex",
          alignItems: "center",
          border: "2px solid red",
          justifyContent: "flex-end",
        };
      } else {
        return {
          display: "flex",
          alignItems: "center",
          borderRight: "1px solid #DFDFDF",
          justifyContent: "flex-end",
        };
      }
    },
    minWidth: 80,
    maxWidth: 150,
    suppressSizeToFit: false,
    icons: {
      menu: `<img src="${searchLogo}" />`,
    },
  },
  {
    headerName: "Full Recall",
    field: "select",
    colId:'select',
    floatingFilter: false,
    floatingFilterComponentParams: { suppressFilterButton: true },
    headerCheckboxSelection: true,
    showDisabledCheckboxes: true,
    checkboxSelection: true,
    editable: false,
    cellStyle: {
      display: "flex",
      alignItems: "center",
      borderRight: "0.5px solid #E1E1E1",
    },
    minWidth: 95,
    maxWidth: 130,
    suppressSizeToFit: false,
    icons: {
      menu: '<i class="fa-solid fa-toggle-on"></i>',
    }
  },
  {
    headerName: "New Recall Qty",
    headerComponentParams: {
      template: `
      <div class="ag-cell-label-container" role="presentation">
    <span ref="eMenu" class="ag-header-icon ag-header-cell-menu-button" aria-hidden="true"></span>
    <div ref="eLabel" class="ag-header-cell-label" role="presentation">
        <img class="me-1" height="14px" width="14px" src="${editIcon}" /> 
        <span ref="eText" class="ag-header-cell-text"></span>
        <span ref="eFilter" class="ag-header-icon ag-header-label-icon ag-filter-icon" aria-hidden="true"></span>
        <span ref="eSortOrder" class="ag-header-icon ag-header-label-icon ag-sort-order" aria-hidden="true"></span>
        <span ref="eSortAsc" class="ag-header-icon ag-header-label-icon ag-sort-ascending-icon" aria-hidden="true"></span>
        <span ref="eSortDesc" class="ag-header-icon ag-header-label-icon ag-sort-descending-icon" aria-hidden="true"></span>
        <span ref="eSortNone" class="ag-header-icon ag-header-label-icon ag-sort-none-icon" aria-hidden="true"></span>
    </div>
</div>`
    },
    field: "newValue",
    type:'rightAligned',
    floatingFilter: false,
    filter: "agTextColumnFilter",
    editable: true,
    floatingFilterComponentParams: { suppressFilterButton: true },
    valueFormatter: myValueFormatter_quantity,
    cellStyle: function (params: any) {
        if (params.node.data.newValue < 0 || (parseFloat(params.node.data.newValue) +parseFloat(params.node.data.recalled_quantity)) > parseFloat(params.node.data.quantity)) {
          return {
            display: "flex",
            alignItems: "center",
            border: "2px solid red",
            justifyContent: "flex-end",
            backgroundColor: status.error
          };
        } else {
          return {
            display: "flex",
            alignItems: "center",
            borderRight: "1px solid #DFDFDF",
            justifyContent: "flex-end",
          };
        }
      },
    minWidth: 90,
    maxWidth: 150,
    suppressSizeToFit: false,
    icons: {
      menu: `<img src="${searchLogo}" />`,
    },
  },
  {
    headerName: "New Remaining Qty",
    field: "remaining_quantity",
    type: "rightAligned",
    valueFormatter: myValueFormatter_quantity,
    floatingFilter: false,
    filter: "agNumberColumnFilter",
    editable: false,
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: function (params: any) {
      if (params.node.data.remaining_quantity < 0) {
        return {
          display: "flex",
          alignItems: "center",
          border: "2px solid red",
          justifyContent: "flex-end",
        };
      } else {
        return {
          display: "flex",
          alignItems: "center",
          borderRight: "1px solid #DFDFDF",
          justifyContent: "flex-end",
        };
      }
    },
    minWidth: 90,
    maxWidth: 150,
    suppressSizeToFit: false,
    icons: {
      menu: `<img src="${searchLogo}" />`,
    },
  },
];